<div *ngIf="!isCheckoutPage">
  <div id="progress_bar" class="cf-progressbar" *ngIf="! mobile && ! hideChapterBar">
    <div class="cf-nav cf-navprev cf_step_previous" [class.hide]="hidePrev">
      <a href="javascript:" (click)="prevBtn()" [ngClass]="{'disabled': disablePrev}">
        <i class="fa fa-angle-left" aria-hidden="true"></i>Back
      </a>
    </div>
    <div class="cf-progress-steps">
      <div id="progress_name" class="cf-progress-step step-name" [ngClass]="chapter1">
        <span>Name</span>
      </div>
      <div id="progress_business" class="cf-progress-step step-business" [ngClass]="chapter2">
        <span>Business</span>
      </div>
      <div id="progress_addons" class="cf-progress-step step-addons" [ngClass]="chapter3">
        <span>Essentials</span>
      </div>
      <div id="progress_services" class="cf-progress-step step-included" [ngClass]="chapter4">
        <span>Services</span>
      </div>
      <div id="progress_speed" class="cf-progress-step step-speed" [ngClass]="chapter5">
        <span>Package</span>
      </div>
      <div id="progress_checkout" class="cf-progress-step step-checkout" [ngClass]="chapter6">
        <span>Checkout</span>
      </div>
    </div>
    <div class="cf-nav cf-navnext cf_step_advance" [class.hide]="hideNext">
      <a href="javascript:" (click)="nextBtn()" *ngIf="! shouldDisableNext()">
        Next
        <i class="fa fa-angle-right" aria-hidden="true"></i>
      </a>
      <a href="javascript:" class="disabled" *ngIf="shouldDisableNext()">
        Next
        <i class="fa fa-angle-right" aria-hidden="true"></i>
      </a>
    </div>
  </div>

  <div id="progress_bar" class="cf-progressbar" *ngIf="mobile && ! hideChapterBar">
    <span id="progress_name" class="cf-progress-step step-name" [ngClass]="chapter1">
      Name
    </span>
    <span id="progress_business" class="cf-progress-step step-business" [ngClass]="chapter2">
      Business
    </span>
    <span id="progress_addons" class="cf-progress-step step-addons" [ngClass]="chapter3">
      Essentials
    </span>
    <span id="progress_services" class="cf-progress-step step-included" [ngClass]="chapter4">
      Services
    </span>
    <span id="progress_speed" class="cf-progress-step step-speed" [ngClass]="chapter5">
      Package
    </span>
    <span id="progress_checkout" class="cf-progress-step step-checkout" [ngClass]="chapter6">
      Checkout
    </span>
  </div>
</div>